import React from "react";
import { useHistory } from "react-router-dom";
import { MdDoNotDisturbAlt } from "react-icons/md";
import "../ErrorPageComponent/ErrorPageComponent.css";
import "./ECatalogSystemClosed.css";

interface Props {
  title?: string;
  message?: string;
}

export const ECatalogSystemClosed = (props: Props) => {
  const history = useHistory();

  return (
    <div className="ecatalog-system-closed">
      <div className="error-page-container">
        <div className="all-text-container">
          <div className="error-text-container">
            <MdDoNotDisturbAlt className="closed-icon" />
            <p className="error-text">
              {props.title || "ระบบปิดปรับปรุงชั่วคราว"}
            </p>
            <p className="not-found-text">
              {props.message || "ขออภัยในความไม่สะดวก กรุณากลับมาใช้งานอีกครั้งในภายหลัง"}
            </p>
          </div>
          <button
            className="go-back-button"
            onClick={() => history.push("/Default")}
          >
            กลับหน้าหลัก
          </button>
        </div>
      </div>
    </div>
  );
};
